export default "__VITE_ASSET__0RYMKMe6__"